<template>
  <div id="home">
    <div class="banner">
      <img src="../../assets/solve/qd_banner.png" class="banner_img" alt />
      <div class="divs">
        <p>
          <img src="../../assets/solve/qd_banner_tit.png" alt />
        </p>
        <p class="chan" @click="heslo()">加入合作</p>
      </div>
    </div>
    <div class="channel">
      <div class="channel_one">
        <div class="channel_one1">
          <p class="h1">为您提供六大支持</p>
          <ul class="channel_li">
            <li>
              <img src="../../assets/solve/qd_card_bg.png" class="channel_img" />
              <div class="channel1">
                <div class="channel1_one">
                  <p>
                    <img src="../../assets/solve/qd-a_icon_01.png" alt />
                  </p>
                  <p>技术保障</p>
                </div>
                <p class="qiangdas">强大的技术团队保证系统安全稳定运行，根据市场需求不断优化升级</p>
              </div>
            </li>
            <li>
              <img src="../../assets/solve/qd_card_bg.png" class="channel_img" />
              <div class="channel1">
                <div class="channel1_one">
                  <p>
                    <img src="../../assets/solve/qd-a_icon_02.png" alt />
                  </p>
                  <p>培训支持</p>
                </div>
                <p class="qiangdas">总部进行全程运营培训指导，定期举办集中培训，并给与课件及远程视频培训</p>
              </div>
            </li>
            <li>
              <img src="../../assets/solve/qd_card_bg.png" class="channel_img" />
              <div class="channel1">
                <div class="channel1_one">
                  <p>
                    <img src="../../assets/solve/qd-a_icon_03.png" alt />
                  </p>
                  <p>服务与支持</p>
                </div>
                <p class="qiangdas">提供全方位的物料及广告支持，一对一的人工客服支持</p>
              </div>
            </li>
            <li>
              <img src="../../assets/solve/qd_card_bg.png" class="channel_img" />
              <div class="channel1">
                <div class="channel1_one">
                  <p>
                    <img src="../../assets/solve/qd-a_icon_04.png" alt />
                  </p>
                  <p>超低低价</p>
                </div>
                <p class="qiangdas">销售价的80%给到代理商</p>
              </div>
            </li>
            <li>
              <img src="../../assets/solve/qd_card_bg.png" class="channel_img" />
              <div class="channel1">
                <div class="channel1_one">
                  <p>
                    <img src="../../assets/solve/qd-a_icon_05.png" alt />
                  </p>
                  <p>会销支持</p>
                </div>
                <p class="qiangdas">结合当地实际情况总部派讲师在当地进行企业服务论坛及商会运营等主题会议，促进线上交易成单</p>
              </div>
            </li>
            <li>
              <img src="../../assets/solve/qd_card_bg.png" class="channel_img" />
              <div class="channel1">
                <div class="channel1_one">
                  <p>
                    <img src="../../assets/solve/qd-a_icon_06.png" alt />
                  </p>
                  <p>政策红利</p>
                </div>
                <p class="qiangdas">国家大力支持企业数字化转型升级</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="channel_two">
        <div class="channel_two1">
          <p class="h2">合伙人合作条件</p>
          <div class="channel_two_con">
            <ul>
              <li>
                <p>
                  <img src="../../assets/solve/qd-a_icon_01(1).png" alt />
                </p>
                <p>法人资质</p>
                <p>具有独立法人资质，有良好的商业信誉和口碑，在当地有一定人脉资源</p>
              </li>
              <li>
                <p>
                  <img src="../../assets/solve/qd-a_icon_02(1).png" alt />
                </p>
                <p>理念</p>
                <p>认可商企服文化理念，愿意伴随成长</p>
              </li>
              <li>
                <p>
                  <img src="../../assets/solve/qd-a_icon_03(1).png" alt />
                </p>
                <p>模式</p>
                <p>认可互联网+企业服务的模式，渴望极大扩展政务、商会、企业等高端人脉资源</p>
              </li>
              <li>
                <p>
                  <img src="../../assets/solve/qd-a_icon_04(1).png" alt />
                </p>
                <p>背景</p>
                <p>具有互联网背景，了解企业服务、SCSS行业，或有商会或者政府从业背景</p>
              </li>
              <li>
                <p>
                  <img src="../../assets/solve/qd-a_icon_05(1).png" alt />
                </p>
                <p>能力&意识</p>
                <p>具备一定的市场拓展和业务谈判能力,具备投资或创业意识</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="channel_three">
        <div class="channel_three_con">
          <div class="channel_three-one">
            <p class="h1">预期收益</p>
            <img src="../../assets/solve/qd-b_bg.png" alt />
          </div>
          <div class="channel_three-two">
            <p class="h3">简单五步，开启合作</p>
            <ul class="three_li">
              <li>
                <img src="../../assets/solve/qd-c_icon_01.png" alt />
                <p>申请审核</p>
              </li>
              <li>
                <img src="../../assets/solve/jj-c_icon_06.png" alt />
              </li>
              <li>
                <img src="../../assets/solve/qd-c_icon_02.png" alt />
                <p>签署合作协议</p>
              </li>
              <li>
                <img src="../../assets/solve/jj-c_icon_06.png" alt />
              </li>
              <li>
                <img src="../../assets/solve/qd-c_icon_03.png" alt />
                <p>培训</p>
              </li>
              <li>
                <img src="../../assets/solve/jj-c_icon_06.png" alt />
              </li>
              <li>
                <img src="../../assets/solve/qd-c_icon_04.png" alt />
                <p>客户开发</p>
              </li>
              <li>
                <img src="../../assets/solve/jj-c_icon_06.png" alt />
              </li>
              <li>
                <img src="../../assets/solve/qd-c_icon_05.png" alt />
                <p>收益</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="floor">
      <div class="floor_1">
        <div class="floor_top">
          <p class="floor_onep" style="color:#fff;">共赢互联网+时代，享亿万商机</p>
          <p class="chan" @click="heslo()">加入合作</p>
        </div>
      </div>
      <div class="floor_2">
        <div class="floor_left">
          <p class="floor_img">
            <img src="../../assets/home/bottom_logo.png" alt />
          </p>
          <div class="floor_left_1">
            <p>商汇（天津）信息技术有限公司</p>
            <p>联系电话：022-8821-9596</p>
          </div>
          <div class="floor_left_2">
            <p>
              <a
                href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action"
                target="_blank"
              >津ICP备19005305号-6</a>
            </p>
            <p>
              <img src="../../assets/home/bottom_icon.png" alt />
            </p>
            <p>
              <a
                href="https://www.beian.gov.cn/portal/index.do"
                target="_blank"
              >公安网备案12010302001766号</a>
            </p>
          </div>
        </div>
        <div class="floor_right">
          <div class="floor_right_1">
            <p class="floor_right_p">产品介绍</p>
             <ul class="floor_right_ul1" @click="add()">
              <li>
                <a href="#1">提升品牌</a>
              </li>
              <li>
                <a href="#2">降低成本</a>
              </li>
              <li>
                <a href="#3">一键转发</a>
              </li>
              <li>
                <a href="#4">电子名片</a>
              </li>
              <li>
                <a href="#5">数据追踪</a>
              </li>
            </ul>
            <ul class="floor_right_ul2" @click="add()">
              <li>
                <a href="#6">智能报表</a>
              </li>
              <li>
                <a href="#7">智能管理</a>
              </li>
              <li>
                <a href="#8">员工管理</a>
              </li>
              <li>
                <a href="#9">智能AI拓客</a>
              </li>
            </ul>
          </div>
          <div class="floor_right_1">
            <p class="floor_right_p1">解决方案</p>
            <ul class="floor_right_ul1">
              <li><a href="#10" @click="solve()">服务内容</a></li>
              <li><a href="#11" @click="solve()">服务价格</a></li>
              <li><a href="#12" @click="solve()">服务流程</a></li>
              <li @click="heslo()"><a>渠道合作</a></li>
            </ul>
          </div>
          <div class="floor_right_1">
            <p class="floor_right_p2">关于我们</p>
            <ul class="floor_right_ul1">
              <li @click.stop="addqi()"><a>企业介绍</a></li>
              <li @click.stop="addqi1()"><a>奖项荣誉</a></li>
              <li @click.stop="addqi2()"><a>新闻资讯</a></li>
              <li @click.stop="addqi3()"><a>联系我们</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="helsoe" width="900px">
      <div class="hesll" style="margin-bottom:20px;">
        <p>申请成为合作人</p>
        <p>请添加您的信息，我们将第一时间与您联系</p>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm"
      >
        <el-form
          :inline="true"
          :model="ruleForm"
          :rules="rules"
          class="demo-form-inline"
          label-width="200px"
        >
          <el-form-item label="姓名：" prop="name" style="margin-bottom:20px;">
            <el-input v-model="ruleForm.name" style="width:200px" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="申请区域：" prop="application_area">
            <el-cascader
              :options="options"
              :props="defaultParams"
              :change-on-select="true"
              :clearable="true"
              v-model="ruleForm.application_area"
              @change="handleChange"
              ref="cascaderAddr"
              style="width:200px;"
            ></el-cascader>
          </el-form-item>
        </el-form>
        <el-form-item label="手机号：" prop="phone" style="margin-bottom:20px;">
          <div class="phone">
            <input type="text" placeholder="请输入您的手机号" v-model="ruleForm.phone" />
            <!-- <p>|</p>
            <input type="text" placeholder="请输入验证码" class="inouts" />
            <button @click="getCode1()" class="code-btn" :disabled="!show">
              <span v-show="show">获取验证码</span>
              <span v-show="!show" class="count">重新发送({{count}})</span>
            </button>-->
          </div>
        </el-form-item>
        <el-form-item label="公司名称：" prop="company_name">
          <el-input v-model="ruleForm.company_name" style="width:80%" placeholder="请选输入公司名称"></el-input>
        </el-form-item>"
        <el-form-item label="所在地区：" style="margin-bottom:20px;">
          <el-input v-model="ruleForm.location" style="width:80%" placeholder="请选输入公司所在地区"></el-input>
        </el-form-item>
        <el-form-item label="公司概况：" style="margin-bottom:20px;">
          <el-input v-model="ruleForm.company_survey" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" class="bitton">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')" class="bitton1">取消</el-button>
        </el-form-item>
      </el-form>
      <div class="floors">
        <p>如有疑问，可拨打咨询热线： 022-8821-9596</p>
      </div>
    </el-dialog>
  </div>
</template> 

<script>
import { getintention_agen_add_sub } from "@/config/api";
import arrAll from "@/tools/option";
export default {
  data() {
    return {
      helsoe: false,
      options: [],
      count: "",
      show: true,
      TIME_COUNT: 60, //验证码倒计时60s
      defaultParams: {
        label: "name",
        value: "name",
        children: "children"
      },
      ruleForm: {
        name: "",
        phone: "",
        application_area: "",
        company_survey: "",
        company_name: "",
        location: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        application_area: [
          { required: true, message: "请选择申请区域", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    apply() {},
    home() {
      this.$router.push({
        name: "home"
      });
    },
    heslo() {
      this.helsoe = true;
    },
    handleChange(value) {
      let labels = this.$refs["cascaderAddr"].currentLables;
    },
    //注册并登录
    getCode1() {
      if (!this.timer) {
        this.count = this.TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= this.TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //优质服务商
    getManagement() {
      this.$http(
        "https://www.newcoc.cn/WebProgram/WebApi/getRegionList",
        "post"
      ).then(res => {
        this.options = res.data.data;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.application_area = this.ruleForm.application_area.toString();
          getintention_agen_add_sub(this.ruleForm).then(res => {
            if (res.code == "20000") {
              this.$message({
                message: "申请成功",
                type: "success"
              });
              this.helsoe = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.name = "";
      this.ruleForm.application_area = "";
      this.ruleForm.company_survey = "";
      this.ruleForm.location = "";
      this.helsoe = false;
    },
    add() {
      var num = 1;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/product"
      });
      this.$router.go(0);
    },
    addqi() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 0
        }
      });
      this.$router.go(0);
    },
    addqi1() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 1
        }
      });
      this.$router.go(0);
    },
    addqi2() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 2
        }
      });
      this.$router.go(0);
    },
    addqi3() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 3
        }
      });
      this.$router.go(0);
    },
    solve() {
      var num = 2;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/solve"
      });
      this.$router.go(0);
    }
  },
  created() {
    this.getManagement();
    this.$emit("footer", false); //是否显示头部
  }
};
</script>

<style scoped>
@import "../../components/style.css";
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
  /* overflow: hidden; */
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background-color: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background-color: #409eff;
}

.add {
  margin-left: 5px;
}

.banner {
  width: 100%;
  height: 400px;
  position: relative;
}

.banner_img {
  width: 100%;
  height: 400px;
}

.divs {
  width: 760px;
  height: 102px;
  position: absolute;
  top: 148px;
  left: 50%;
  margin-left: -380px;
}

.divs img {
  width: 760px;
  height: 116px;
  text-align: center;
  font-size: 46px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin: 0 auto;
}

.chan {
  width: 160px;
  height: 42px;
  background: linear-gradient(
    90deg,
    rgba(255, 207, 136, 1),
    rgba(255, 189, 119, 1)
  );
  border-radius: 4px;
  margin: 40px auto;
  text-align: center;
  line-height: 42px;
  color: #65513d;
  cursor: pointer;
}

.channel {
  width: 100%;
}

.channel_one {
  width: 100%;
  height: 711px;
}

.channel_one1 {
  width: 1200px;
  margin: 0 auto;
}

.h1 {
  font-size: 34px;
  color: rgba(51, 51, 51, 1);
  margin: 100px 0 78px 0;
  text-align: center;
}

.h2 {
  font-size: 34px;
  color: rgba(51, 51, 51, 1);
  margin: 100px 0 78px 0;
  text-align: center;
}

.h3 {
  font-size: 34px;
  color: rgba(51, 51, 51, 1);
  margin: 94px 0 63px 0;
  text-align: center;
}

.channel_li {
  width: 1100px;
  margin: 0 auto;
}

.channel_li li {
  position: relative;
  width: 365px;
  height: 205px;
  overflow: hidden;
  float: left;
}

.channel_img {
  position: absolute;
  z-index: -1;
}

.channel1_one {
  width: 100%;
  height: 34px;
  margin: 51px 0 22px 31px;
  overflow: hidden;
}

.channel1_one p {
  float: left;
}

.channel1_one p:last-child {
  line-height: 34px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-left: 11px;
}

.qiangdas {
  width: 300px;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
  line-height: 30px;
}

.channel_two {
  width: 100%;
  height: 565px;
  background: #fafbfd;
}

.channel_two1 {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.channel_two_con {
  width: 1085px;
  height: 283px;
  margin: 0 auto;
}

.channel_two_con ul li {
  width: 215px;
  height: 283px;
  border-right: 1px solid #e1e6f0;
  overflow: hidden;
  float: left;
}

.channel_two_con ul li:nth-child(5) {
  border: 0;
}

.channel_two_con ul li p {
  text-align: center;
}

.channel_two_con ul li p:nth-child(1) {
  margin: 48px 0 38px 0;
}

.channel_two_con ul li p:nth-child(2) {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 126, 255, 1);
  margin-bottom: 18px;
}

.channel_two_con ul li p:nth-child(3) {
  width: 172px;
  height: 63px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
  margin: 0 auto;
}

.channel_two_con ul li:hover {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.channel_three {
  width: 100%;
  height: 964px;
}

.channel_three_con {
  width: 1200px;
  margin: 0 auto;
}

.channel_three-one {
  width: 100%;
  height: 434px;
}

.three_li {
  width: 100%;
}

.three_li li {
  width: 174px;
  text-align: center;
  float: left;
}

.three_li li:nth-child(2),
.three_li li:nth-child(4),
.three_li li:nth-child(6),
.three_li li:nth-child(8) {
  width: 82px;
  margin-top: 64px;
}

.three_li p {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 22px;
}

.products,
.productsa {
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.hesll {
  text-align: center;
}

.hesll p:first-child {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 12px;
}

.hesll p:last-child {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.phone {
  width: 80%;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  display: flex;
  position: relative;
}

.phone input {
  border: 0;
  outline: 0;
  padding: 0 10px;
}

.phone p {
  color: #d7d7db;
}

.inouts {
  margin: 0 30px;
}

.code-btn {
  width: 115px;
  height: 40px;
  position: absolute;
  right: 0;
  z-index: 222;
  color: #fff;
  font-size: 14px;
  border: none;
  background-color: #337eff;
  cursor: pointer;
  outline: none;
  border-radius: 0px 4px 4px 0px;
}

.bitton {
  width: 202px;
  height: 44px;
  background: rgba(51, 126, 255, 1);
  border-radius: 4px;
}

.bitton1 {
  width: 134px;
  height: 44px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 223, 230, 1);
  border-radius: 4px;
}

.floors {
  width: 100%;
  height: 54px;
  background: rgba(241, 244, 248, 1);
  border-radius: 0px 0px 10px 10px;
  margin-top: 30px;
}

.floors p {
  text-align: center;
  line-height: 54px;
  color: #98abc1;
}

.floor_onep {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 60px 0 40px 0;
}

.floor {
  width: 100%;
  height: 553px;
  background: #0a1633;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 54px;
}

.floor_top {
  width: 100%;
  height: 207px;
  border-bottom: 1px solid #263758;
}

.floor_top p:nth-child(2) {
  text-align: center;
}

.shsess {
  width: 140px;
  height: 44px;
}

.shses {
  width: 140px;
  height: 44px;
  background: linear-gradient(
    90deg,
    rgba(255, 207, 135, 1),
    rgba(255, 189, 119, 1)
  );
  border-radius: 4px;
  outline: 0;
}

.floor_left {
  width: 600px;
  color: #9ba5b4;
  font-size: 14px;
  float: left;
}

.floor_2 {
  width: 1200px;
  margin: 0 auto;
}

.floor_img {
  margin-bottom: 30px;
}

.floor_left_1 {
  line-height: 30px;
  margin-bottom: 30px;
}

.floor_left_2 p {
  float: left;
  line-height: 22px;
}

.floor_left_2 p img {
  margin: 0 5px;
}

.floor_right {
  width: 600px;
  float: right;
  color: #9ba5b4;
}

.floor_right_1 {
  float: left;
  margin-right: 80px;
}

.floor_right_1:nth-child(3) {
  margin-right: 0;
}

.floor_right_p {
  width: 189px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p1 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p2 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_ul1 {
  font-size: 12px;
  float: left;
  margin-right: 39px;
}

.floor_right_ul1 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul1 li a {
  margin-bottom: 10px;
  cursor: pointer;
  color: #9ba5b4;
  text-decoration: none;
}

.floor_right_ul2 li a {
  margin-bottom: 10px;
  cursor: pointer;
  color: #9ba5b4;
  text-decoration: none;
}

.floor_right_ul2 {
  font-size: 12px;
}

.floor_right_ul2 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 li a:hover {
  color: #fff;
}

.floor_right_ul1 li a:hover {
  color: #fff;
}

.floor_left_2 p:nth-child(3) a,
.floor_left_2 p:nth-child(1) a {
  color: #9ba5b4;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/view/channel/channel.vue